import React from 'react';
import API from "../../Services/BaseService";
import { useHistory } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import ManageAccountLinks from "../../Component/ManageAccountLinks/ManageAccountLinks"
import Loading from "../../Component/Loading/Loading";
import localStorage from 'local-storage';
import { useSelector, useDispatch } from 'react-redux';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import { Button } from 'antd';
import PageNotFound from '../FallBackUI/PageNotFound';
import DealerAction from '../DealerRedux/DealerAction';
import ls from 'local-storage';

const ManageAccount = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [accountDetails, setaccountDetails] = useState("");
  const [dealerInfo, setDealerInfo] = useState();
  const [status, setStatus] = useState([]);
  const [addressDetails, setaddressDetails] = useState([]);
  const [legaldetails, setLegalDetails] = useState([]);
  const [loading, setLoading] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const sellerDetails = localStorage.get("sellerDetails");
  const successData = useSelector(state => state.LoginReducer.payload);
  const dealerData = useSelector(state => state.DealerReducer.payload);
  console.log("dealerData checking====", dealerData)
  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  const [dealerList, setDealerList] = useState("");
  const [dealerStatus, setDealerStatus] = useState("");
  const [dealerId, setDealerId] = useState("");
  const [selectedSellerDetails, setSelectedSellerDetails] = useState("");
  const [flagFilter, setFalgFilter] = useState(false);
  const [selectSellerId, setselectSellerid] = useState("");

  const backUrl = ls.get("backredirection");
  console.log("check the back url", backUrl);
  const back = backUrl[(backUrl.length) - 1];
  console.log("checking the ls.set", backUrl[(backUrl.length) - 1]);

  const billofsale = ls.get("BillofSaleId")
  const CarId = ls.get("BillOfSaleCarId")
  console.log("check the bill of sale value", billofsale);
  // const [extentation, setExtentation] = useState("");
  // const [extentationmob, setExtentationmob] = useState("");



  console.log("manage acc", successData)
  function fetchAccountDetails(data) {
    setLoading(true);
    console.log("===JSON.parse(localStorage.getItem====>", localStorage.get("sellerDetails"))
    let request = {
      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data,
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    };
    const state = API.post('seller_dealer_profile/condition', request);
    state.then(res => {
      console.log("res==data====>", res.data)
      if (res.data.success === true) {
        setaccountDetails(res.data.data);
        setDealerInfo(res.data.data);
        console.log("Dealerstatus", res.data.data[0]?.Dealerstatus)

        setStatus(res.data.data[0]?.Dealerstatus)
      }

      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
      }
    });
  }
  function fetchAddressDetails(data) {
    let request = {
      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data,
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    };
    const state = API.post('sellerAddress/condition', request);
    state.then(res => {
      console.log("res", res)
      if (res.data.success === true) {
        setaddressDetails(res.data.data);
        console.log("setaddressDetails", res.data.data);
        // setExtentation(res.data.data.extentation);
        // setExtentationmob(res.data.data.mobile_extentation);
        if (res.data.data[0]?.mobile_no != "" && res.data?.data[0]?.mobile_no != null) {
          formatMobileNO(res.data.data[0]?.mobile_no)
        }
        if (res.data.data[0]?.phone_no != "" && res.data?.data[0]?.phone_no != null) {
          formatPhoneNO(res.data.data[0]?.phone_no)
        }
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
      }
    });
  }


  function fetchLegalDetails(data) {
    let request = {
      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: successData.seller_dealer_id :data,
      seller_dealer_id: data == undefined || data === null ? successData.seller_dealer_id : data.seller_dealer_id,

      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    };
    const state = API.post('legalaccount/condition', request);
    state.then(res => {
      console.log("res dat", res.data)
      if (res.data.success === true) {
        if (res.data.success) {
          setLegalDetails(res.data.data);
        }
        setLoading(false);
      }
      else {
        setErrors(res.data.error)
        setErrorFlag(true)
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
        setLoading(false);
      }
    });
  }


  function onHandleEdit(item) {
    // console.log("legallllllllllll",e)
    history.push({
      pathname: "/legaledit",
      state: { id: item.seller_legal_manage_id, BillofSale: billofsale, CarId: CarId }
    })
    ls.set("backredirection", [...backUrl, "/manageaccount"])
    ls.set("BillofSaleId", billofsale)
  };

  function onHandleDealerEdit(item) {
    history.push({
      pathname: "/dealerinfoedit",
      state: { id: item.seller_dealer_id, BillofSale: billofsale, CarId: CarId }
    });
    ls.set("backredirection", [...backUrl, "/manageaccount"])
    ls.set("BillofSaleId", billofsale)
  }

  // function onHandleDealerEdit(item) {
  //   history.push(pathname : "/dealerinfoedit/");
  //   state: {urcarBack:"/carlist", id:pathid}

  // }

  function onHandleAddressEdit(item) {
    history.push({
      pathname: "/addressedit",
      state: { id: item.seller_address_id, BillofSale: billofsale, CarId: CarId }
    });
    ls.set("backredirection", [...backUrl, "/manageaccount"])
    ls.set("BillofSaleId", billofsale)
  }

  const handleSellerDetailsName = (e) => {

    setDealerId(e.target.value)
    console.log("=========check seller details name", e.target.value)
    setSelectedSellerDetails(dealerList.filter(data => data.seller_dealer_id == e.target.value)[0])
    console.log("=========check", dealerList.filter(data => data.seller_dealer_id == e.target.value))
    const selectedSellerDetails = dealerList.filter(data => data.seller_dealer_id == e.target.value)[0];
    getDealerInformation(selectedSellerDetails)
    getAddress(selectedSellerDetails)
    getLegalAccount(selectedSellerDetails)
    setselectSellerid(selectedSellerDetails.seller_dealer_id)
    setFalgFilter(true)
    dispatch(DealerAction.searchrequest(selectedSellerDetails));
  }

  useEffect(() => {
    if (dealerData !== null) {

      getDealerInformation(dealerData);
      getAddress(dealerData);
      getLegalAccount(dealerData);
    }
  }, [dealerData])

  const getDealername = (data) => {

    let request = {
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    }
    API.post("dealerNameDynamic/condition", request).then(response => {
      if (response.data.success === true) {


        setDealerList(response.data.data);

      }

      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)
      }


    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }
  const getDealerInformation = (data) => {

    let request = {
      seller_dealer_id: data.seller_dealer_id,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token
    }
    API.post("seller_dealer_profilefilter/condition", request).then(response => {
      if (response.data.success === true) {
        setaccountDetails(response.data.data);

        setDealerInfo(response.data.data);

      }

      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)
      }


    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }
  const getAddress = (data) => {

    let request = {
      seller_dealer_id: data.seller_dealer_id,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token
    }
    API.post("sellerAddressfilter/condition", request).then(response => {
      if (response.data.success === true) {


        setaddressDetails(response.data.data);

      }

      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)
      }


    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }
  const getLegalAccount = (data) => {

    let request = {
      seller_dealer_id: data.seller_dealer_id,
      seller_id: successData.seller_id,
      seller_token: successData.seller_token
    }
    API.post("legalaccountfilter/condition", request).then(response => {
      if (response.data.success === true) {


        setLegalDetails(response.data.data);

      }

      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)
      }


    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
  }

  useEffect(() => {
    fetchAccountDetails(dealerData);
    fetchLegalDetails(dealerData);
    fetchAddressDetails(dealerData);
    getDealername();
    // setLoading(false);    
  }, [dealerData]);
  function formatMobileNO(value) {
    var x = value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
    console.log("value of x", x);
    value = '(' + x[1] + ') ' + x[2] + '-' + x[3];
    console.log("mobileno", value);
    return setPhoneNo(value);
  }
  function formatPhoneNO(value) {
    var x = value.replace(/\D/g, '').match(/(\d{3})(\d{3})(\d{4})/);
    console.log("value of x", x);
    value = '(' + x[1] + ') ' + x[2] + '-' + x[3];
    console.log("mobileno", value);
    return setMobileNo(value);
  }

  const handleBackButton = () => {

    history.push({
      pathname: back,
      state: { BillofSale: billofsale, CarId: CarId },
    });
    ls.set("backredirection", backUrl.slice(0, -1))

  }

  const handleFlag = () => {
    ls.set("BillofSaleId", "")
    ls.get("BillOfSaleCarId", "")
  }

  return (
    <div>
      {loading ? <Loading /> :
        <main id="main" className="inner-page">
          {errorFlag === true ? <PageNotFound error={errors} /> :
            <div id="mgaccount" className="mgaccount">
              <div className="container-fluid inner-page-space" >

                <div class="common-heading">
                  <div className="row">
                    <div className="col-lg-4">
                      <div class="back-btn">
                        <a class="back-btn-primary" onClick={() => handleBackButton()}>
                          <i class="bx bx-chevron-left"></i> Back
                        </a>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div class="title">
                        <p class="inner-title">Manage Account</p>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div class="title-dropdown">
                        <div class="tbox dealename-dropdown">
                          <select class="form-control box pad-ing " id="drop" placeholder="" className={`${dealerData != null ? (dealerData?.color == "pink"
                            ? "tableRowPink  form-control box"
                            : dealerData?.color == "firered"
                              ? "tableRowFireRed  form-control box"
                              : dealerData?.color == "green"
                                ? "tableRowGreenColor form-control box"
                                : dealerData?.color == "darkred"
                                  ? "tableRowRed1  form-control box"
                                  : " form-control box") :
                            (dealerList[0]?.color == "pink"
                              ? "tableRowPink  form-control box"
                              : dealerList[0]?.color == "firered"
                                ? "tableRowFireRed  form-control box"
                                : dealerList[0]?.color == "green"
                                  ? "tableRowGreenColor form-control box"
                                  : dealerList[0]?.color == "darkred"
                                    ? "tableRowRed1  form-control box"
                                    : " form-control box")
                            }`} onChange={handleSellerDetailsName}>
                            {dealerData != null ?
                              <option value={null} style={{ "display": "none" }}>{dealerData.dealer_name}({dealerData?.seller_dealer_id})</option> :
                              <option value={null} style={{ "display": "none" }}>{dealerList[0]?.dealer_name}({dealerList[0]?.seller_dealer_id})</option>}

                            {dealerList.length > 0 &&
                              <>
                                {dealerList.map((dealerList, index) => <option className={dealerList?.color == "pink"
                                  ? "tableRowPink  user_name"
                                  : dealerList?.color == "Silver"
                                    ? "tableRowSilver  user_name"
                                    : dealerList?.color == "Orange"
                                      ? "tableRowOrange  user_name"
                                      : dealerList?.color == "Navy blue"
                                        ? "tableRowNavyBlue  user_name"
                                        : dealerList?.color == "firered"
                                          ? "tableRowFireRed  user_name"
                                          : dealerList?.color == "Purple"
                                            ? "tableRowPurple  user_name"
                                            : dealerList?.color == "Yellow"
                                              ? "tableRowYellow1  user_name"
                                              : dealerList?.color == "green"
                                                ? "tableRowGreenColor user_name"
                                                : dealerList?.color == "blue"
                                                  ? "tableRowBlue  user_name"
                                                  : dealerList?.color == "darkred"
                                                    ? "tableRowRed1  user_name"
                                                    : dealerList?.color == "black"
                                                      ? "tableRowBlack1 user_name"
                                                      : " user_name"} key={dealerList.seller_dealer_id} value={dealerList.seller_dealer_id}  >{dealerList.dealer_name}({dealerList?.seller_dealer_id})</option>)}
                              </>
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mgaccountblock col-lg-12">
                  <div className="row content">
                    <div className="col-lg-4 col-md-12 col-sm-12 mgaccountleftblock">
                      <ManageAccountLinks handleFlag={handleFlag} />
                    </div>
                    <div className="col-lg-8 col-md-12 col-sm-12 mgaccountrightblock">
                      {dealerInfo?.length > 0 ? "" :
                        <h3>Dealer Information</h3>}
                      {dealerInfo?.length > 0 ? dealerInfo?.map((item, index) =>
                        <div className="mgaccountrighttableblock">
                          <h3>Dealer Information <span>
                            {(status == "Dealer" && dealerData === null) ?
                              <Button className="ant-btn" onClick={() => onHandleDealerEdit(item)}><i className="icofont-ui-edit"></i> Edit</Button> :
                              (status == "Dealer" && (dealerData?.dealer_name === successData?.dealer_name)) ?
                                <Button className="ant-btn" onClick={() => onHandleDealerEdit(item)}><i className="icofont-ui-edit"></i> Edit</Button>
                                : ""}
                          </span></h3>
                          <div className="mgaccountrighttable">
                            <div class="m-account-table">
                              <div className='table-responsive'>
                                <table>
                                  <thead></thead>
                                  <tr>
                                    <td><span className="tdcol1">Seller Dealer # </span><span className={item.seller_dealer_id != "" ?
                                      item.dealercolor == "pink"
                                        ? "tableRowPink "
                                        : item.dealercolor == "Silver"
                                          ? "tableRowSilver "
                                          : item.dealercolor == "Orange"
                                            ? "tableRowOrange "
                                            : item.dealercolor == "Navy blue"
                                              ? "tableRowNavyBlue "
                                              : item.dealercolor == "firered"
                                                ? "tableRowFireRed "
                                                : item.dealercolor == "Purple"
                                                  ? "tableRowPurple "
                                                  : item.dealercolor == "Yellow"
                                                    ? "tableRowYellow1 "
                                                    : item.dealercolor == "green"
                                                      ? "tableRowGreenColor "
                                                      : item.dealercolor == "blue"
                                                        ? "tableRowBlue "
                                                        : item.dealercolor == "darkred"
                                                          ? "tableRowRed1 "
                                                          : item.dealercolor == "black"
                                                            ? "tableRowBlack1 "
                                                            : "" : ""}
                                    >{item.seller_dealer_id}</span></td>
                                    <td><span className="tdcol1">Seller Dealer Name</span><span>{item.dealer_name}</span></td>

                                  </tr>
                                  <tr>
                                    <td><span className="tdcol1">Address </span><span>{item.address}</span></td>
                                    <td><span className="tdcol1">State</span><span>{item.state_name}</span></td>

                                  </tr>
                                  <tr>
                                    <td><span className="tdcol1">City</span><span>{item.city_name}</span></td>
                                    <td><span className="tdcol1">Zip code</span><span>{item.zipcode}</span></td>
                                  </tr>
                                </table>
                              </div>

                            </div>
                          </div>
                        </div>
                      ) : ""}
                      {addressDetails.length > 0 ? addressDetails.map((item, index) =>
                        <div className="mgaccountrighttableblock mt-3 pt-4">
                          <h3>Address<span>
                            {(status == "Dealer" && dealerData === null) ?
                              <Button className="ant-btn" onClick={() => onHandleAddressEdit(item)}><i className="icofont-ui-edit"></i> Edit</Button> :
                              (status == "Dealer" && (dealerData?.dealer_name === successData?.dealer_name)) ?
                                <Button className="ant-btn" onClick={() => onHandleAddressEdit(item)}><i className="icofont-ui-edit"></i> Edit</Button>

                                : ""} </span>
                          </h3>
                          <p>Location where transport carriers will drop of a vehicle that you have purchased</p>
                          <div className="mgaccountrighttable">
                            <div class="m-account-table">
                              <div className='table-responsive'>
                                <table>
                                  <thead></thead>
                                  <tr>
                                    <td><span className="tdcol1">First Name</span><span>{item.first_name}</span></td>
                                    <td><span className="tdcol1">Address</span><span>{item.address}</span></td>
                                  </tr>
                                  <tr>
                                    <td><span className="tdcol1">Last Name</span><span>{item.last_name}</span></td>
                                    <td><span className="tdcol1">City</span><span>{item.city_name}</span></td>
                                  </tr>
                                  <tr>
                                    <td><span className="tdcol3">Primary Phone #</span><span className='view-extn'>{item.country_code}{mobileNo}</span></td>
                                    <td><span className="tdcol1">Extension</span><span>{(item.extentation !== "null" && item.extentation !== null) ? item.extentation : ''}</span></td>
                                  </tr>
                                  <tr>
                                    <td><span className="tdcol3">Mobile Phone #</span><span className='view-extnmob'>{item.mobile_country_code}{phoneNo}</span></td>
                                    <td><span className="tdcol1">Extension</span><span>{(item.mobile_extentation !== "null" && item.mobile_extentation !== null) ? item.mobile_extentation : ''}</span></td>
                                  </tr>
                                  <tr>
                                    <td><span className="tdcol1">State</span><span>{item.state_name}</span></td>
                                    <td><span className="tdcol1">Zip code</span><span>{item.zipcode}</span></td>
                                  </tr>
                                  <tr>
                                    <td><span className="tdcol1">Location Name</span><span>{item.location}</span></td>
                                    <td><span className="tdcol1">Instructions</span><span>{item.instructions}</span></td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) :
                        <div className="mgaccountrighttableblock mt-3 pt-4">
                          <h3>Address<span>
                            {(status == "Dealer" && dealerData === null) ?
                              <Button className="ant-btn" onClick={() => history.push("/addressadd")}><i className="icofont-ui-edit"></i> Add</Button> :
                              (status == "Dealer" && (dealerData?.dealer_name === successData?.dealer_name)) ?
                                <Button className="ant-btn" onClick={() => history.push("/addressadd")}><i className="icofont-ui-edit"></i> Add</Button>
                                : ""}
                          </span>
                          </h3>
                        </div>
                      }
                      {legaldetails.length > 0 ? legaldetails.map((item, index) =>
                        <div className="mgaccountrighttableblock mt-3 pt-4">

                          <h3>Legal Manage Account<span>
                            {(status == "Dealer" && dealerData === null) ?
                              <Button className="ant-btn" onClick={() => onHandleEdit(item)}><i className="icofont-ui-edit"></i> Edit</Button> :

                              (status == "Dealer" && (dealerData?.dealer_name === successData?.dealer_name)) ?

                                <Button className="ant-btn" onClick={() => onHandleEdit(item)}><i className="icofont-ui-edit"></i> Edit</Button>

                                : ""} </span>
                          </h3>
                          <p>Legal document sent to your address</p>
                          <div className="mgaccountrighttable">
                            <div class="m-account-table">
                              <div className='table-responsive'>
                                <table>
                                  <thead></thead>
                                  <tr>
                                    <td><span className="tdcol1">First Name</span><span>{item.first_name}</span></td>
                                    <td><span className="tdcol1">Address</span><span>{item.address}</span></td>
                                  </tr>
                                  <tr>
                                    <td><span className="tdcol1">Last Name</span><span>{item.last_name}</span></td>
                                    <td><span className="tdcol1">City</span><span>{item.city_name}</span></td>
                                  </tr>
                                  <tr>
                                    <td><span className="tdcol1">Legal Business Name</span><span>{item.bussiness_name}</span></td>
                                    <td><span className="tdcol1">State</span><span>{item.state_name}</span></td>
                                  </tr>
                                  <tr>
                                    <td><span className="tdcol1">EIN Number</span><span>{item.ein_no}</span></td>
                                    <td><span className="tdcol1">Zip code</span><span>{item.zipcode}</span></td>
                                  </tr>
                                  <tr>
                                    <td><span className="tdcol1">Dealership License</span><span>{item.seller_license}</span></td>
                                    <td><span className="tdcol1">Dealership License Exp</span><span>{item.seller_license_exp}</span></td>
                                  </tr>
                                  <tr>
                                    <td><span className="tdcol1">Tax Id</span><span>{item.tax_id}</span></td>
                                    <td><span className="tdcol1">Tax Id Exp</span><span>{item.tax_id_exp}</span></td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) :
                        <div className="mgaccountrighttableblock mt-3 pt-4">
                          <h3>Legal Manage Account<span>
                            {(status == "Dealer" && dealerData === null) ?
                              <Button className="ant-btn" onClick={() => history.push("/legaladd")}><i className="icofont-ui-edit"></i> Add</Button> :
                              (status == "Dealer" && (dealerData?.dealer_name === successData?.dealer_name)) ?
                                <Button className="ant-btn" onClick={() => history.push("/legaladd")}><i className="icofont-ui-edit"></i> Add</Button>

                                : ""}

                          </span> </h3>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>}

        </main>}
      <section id="playstoreBlock" className="playstoreBlock">
        <div className="container">
          <div className="row content">
            <div className="col-lg-12">
              <img src={appstore} />
              <img src={googleplay} />
            </div>
          </div>
        </div>
      </section>
    </div >
  );
};

export default ManageAccount;